import { Limit, OfferFragment } from '@occc/graphql';

type ExtractLimitByTypename<T extends OfferFragment['limits'][0]['__typename']> = Extract<
  OfferFragment['limits'][0],
  { __typename: T }
>;

class LimitHelper {
  isGlobalActivation(limit: Limit): limit is ExtractLimitByTypename<'LimitGlobalActivation'> {
    return limit.__typename === 'LimitGlobalActivation';
  }

  isGlobalActivationInTime(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitGlobalActivationInTime'> {
    return limit.__typename === 'LimitGlobalActivationInTime';
  }

  isGlobalAwardCount(limit: Limit): limit is ExtractLimitByTypename<'LimitGlobalAwardCount'> {
    return limit.__typename === 'LimitGlobalAwardCount';
  }

  isGlobalAwardCountInTime(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitGlobalAwardCountInTime'> {
    return limit.__typename === 'LimitGlobalAwardCountInTime';
  }

  isMembershipActivation(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitMembershipActivation'> {
    return limit.__typename === 'LimitMembershipActivation';
  }

  isMembershipActivationInTime(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitMembershipActivationInTime'> {
    return limit.__typename === 'LimitMembershipActivationInTime';
  }

  isMembershipAwardCount(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitMembershipAwardCount'> {
    return limit.__typename === 'LimitMembershipAwardCount';
  }

  isMembershipAwardCountInTime(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitMembershipAwardCountInTime'> {
    return limit.__typename === 'LimitMembershipAwardCountInTime';
  }

  isInTransactionAwardCount(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitInTransactionAwardCount'> {
    return limit.__typename === 'LimitInTransactionAwardCount';
  }

  isInTransactionProgress(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitInTransactionProgress'> {
    return limit.__typename === 'LimitInTransactionProgress';
  }

  isMembershipProgressInTime(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitMembershipProgressInTime'> {
    return limit.__typename === 'LimitMembershipProgressInTime';
  }

  isMembershipTransactionCount(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitMembershipTransactionCount'> {
    return limit.__typename === 'LimitMembershipTransactionCount';
  }

  isMembershipTransactionCountInTime(
    limit: Limit,
  ): limit is ExtractLimitByTypename<'LimitMembershipTransactionCountInTime'> {
    return limit.__typename === 'LimitMembershipTransactionCountInTime';
  }
}

export const limitHelper = new LimitHelper();
